import React, { useState, useEffect } from 'react'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../utils/loading'
import { Col, Grid, Row } from 'rsuite'
import PrePostTestWidgets from '../../widgets/assessment/PrePostTestWidgets'
import { GetAssessmentPrePostTestForm } from '../../redux/actions/assessment'
import { isEmpty } from 'lodash-es'

export default function PrePostTestForm() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const params = new URLSearchParams(window.location.search)

  const id = params.get('id')
  const assessmentId = params.get('assId')
  const type = params.get('type')
  //const isView = params.get('view')

  useEffect(() => {
    // handleGetSchema(assessmentId)
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await GetAssessmentPrePostTestForm(type, assessmentId, id)
      setSchema(response)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
  }

  if (!schema || isLoading) {
    return <PanalLoadingTemplate />
  }

  return (
    <Grid className="page-home">
      <div className="content-header" style={{ marginTop: 20, textAlign: 'center' }}>
        <Row>
          <Col lg={24} md={24} sm={24} xs={24}>
            <h1>{schema.header}</h1>
          </Col>
        </Row>
        <hr />
      </div>

      {schema.assessmentForm && (
        <PrePostTestWidgets
          schema={schema.assessmentForm}
          //isPreView={isView == 't'}
          isView={!isEmpty(id)}
        />
      )}
    </Grid>
  )
}
